import { UserPlus } from 'lucide-react'

import { TextButton } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { type GrapeAPIErrorType } from '../hooks/GrapeAPIError'
import { useCreateQuote } from '../hooks/useCreateQuote'

// We pass in prospectId to create the quote
export function CreateQuoteButton ({
  prospectId,
  secondary,
  quotingV2Enabled,
  onShowError,
}: {
  prospectId: string;
  secondary?: boolean;
  quotingV2Enabled?: boolean;
  onShowError: (error: GrapeAPIErrorType) => void;
}) {
  const { assign } = useWindowLocation()

  const createQuoteMutation = useCreateQuote({ prospectId })

  const handleClick = () => {
    createQuoteMutation.mutate(
      { quote_type: 'internal_tool' },
      {
        onSuccess: async (data) => {
          const quoteId = data.id
          assign(`${prospectId}/quote/${quoteId}`)
        },
        onError: (error) => {
          onShowError(error)
        },
      }
    )
  }

  if (quotingV2Enabled) {
    return (
      <TextButton
        color='purple'
        onClick={handleClick}
      >
        use old tool
      </TextButton>
    )
  }

  return (
    <button
      type='button'
      className={secondary ? 'btn-secondary' : 'btn-primary'}
      onClick={handleClick}
    >
      <UserPlus size={21} className='mr-1' />
      Create a quote
    </button>
  )
}
